module.exports = __webpack_public_path__ + "images/134e64d079004a07de7b50bbd8706687.png";